/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconMoodConfuzed = createReactComponent("mood-confuzed", "IconMoodConfuzed", [
  ["path", { d: "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", key: "svg-0" }],
  ["path", { d: "M9 10l.01 0", key: "svg-1" }],
  ["path", { d: "M15 10l.01 0", key: "svg-2" }],
  ["path", { d: "M9.5 16a10 10 0 0 1 6 -1.5", key: "svg-3" }]
]);

export { IconMoodConfuzed as default };
//# sourceMappingURL=IconMoodConfuzed.js.map
